<template>
  <AuthCard>
    <div class="text-center mb-4">
      <div class="check-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>
      <h3>Check your email</h3>
      <p class="sub">We've sent a confirmation link to your inbox. Click the link or paste your token below.</p>
    </div>

    <form @submit.prevent="submit">
      <Input
        v-model="token"
        label="Confirmation token"
        name="token"
        placeholder="XXXX-XXXX-XXXX-XXXX"
        :disabled="loading"
        :error="error"
      />
      <Button
        type="submit"
        variant="smooth primary"
        :disabled="loading || !token.trim()"
        :loading="loading"
        class="mt-4 width100"
      >
        Confirm account
      </Button>
    </form>

    <div class="text-center pt-5" style="font-size:0.85rem;">
      Already confirmed?
      <router-link class="ml-3" to="signin">Sign in</router-link>
    </div>
  </AuthCard>
</template>

<script>
  import AuthCard from '../common/AuthCard.vue'
  import Input from '../common/Input.vue'
  import Button from '../common/Button.vue'

  export default {
    name: 'ConfirmRegistrationCheckEmail',
    components: { AuthCard, Input, Button },
    data: () => ({
      token: '',
      loading: false,
      error: '',
    }),
    methods: {
      submit() {
        const clean = this.token.trim().toUpperCase().replace(/\s+/g, '')
        if (!clean) return
        this.$router.push({ name: 'confirmregistration', params: { token: clean } })
      }
    }
  }
</script>

<style scoped>
.check-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(91, 141, 184, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: var(--primary, #5B8DB8);
}

.check-icon svg {
  width: 22px;
  height: 22px;
}

h3 { margin-bottom: 0.4rem; }

.sub {
  font-size: 0.85rem;
  color: #777;
  line-height: 1.5;
  margin-bottom: 0;
}
</style>
